import React, { useEffect, useCallback } from "react";
import useEmblaCarousel from "embla-carousel-react";

const EmblaCarousel = ({ slides }) => {
  const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true });

 
  const autoScroll = useCallback(() => {
    if (!emblaApi) return;
    const interval = setInterval(() => {
      if (emblaApi.canScrollNext()) {
        emblaApi.scrollNext();
      } else {
        emblaApi.scrollTo(0);
      }
    }, 3300);

    return () => clearInterval(interval);
  }, [emblaApi]);

  useEffect(() => {
    const cleanup = autoScroll();
    return cleanup;
  }, [autoScroll]);

  return (
    <div className="embla" ref={emblaRef}>
      <div className="embla__container">
        {slides.map((artwork, index) => (
          <div className="embla__slide" key={index}>
            <img
              src={artwork.image || "broken.jpg"} 
              alt=""
              className="embla__slide__img"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default EmblaCarousel;
